import React, { useEffect, useState } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import {
  Grid,
  TextField,
  Modal,
  makeStyles,
  MenuItem,
  Button,
  Collapse,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import EditIcon from '@material-ui/icons/Edit';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';

import { XMEI_PRIMARY_COLOR, XMEI_SECONDARY_COLOR } from '../../consts/common';

import { instanceAxios } from '../../InstanceAxios';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  loading: {
    marginLeft: '50%',
  },
}));

function CaracteristicasPrefeitura() {
  const [states, setStates] = useState([]);
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const [alert, setAlert] = useState(0);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [idOrder, setIdOrder] = useState('');
  const [order, setOrder] = useState('asc');
  const [originalStates, setOriginalStates] = useState([]);

  const [id, setId] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [cnd, setCnd] = useState('');
  const [system, setSystem] = useState('');
  const [accessMethod, setAccessMethod] = useState('');

  const [accessMethodOptions, setAccessMethodOptions] = useState([
    {
      value: 'CPFRepresentative',
      label: 'CPFRepresentante',
    },
    {
      value: 'CPFResponsible',
      label: 'CPFResponsável',
    },
    {
      value: 'IM',
      label: 'Inscrição Municipal',
    },
    {
      value: 'CNPJ',
      label: 'CNPJ',
    },
    // {
    //   value: 'LoginAlternative',
    //   label: 'LoginAlternative'
    // }
  ]);

  const [tableColumns, setTableColumns] = useState([
    { title: 'Cidade', field: 'cidade', editable: 'never', filtering: false , filterable: true },
    { title: 'Estado', field: 'estado', editable: 'never', filtering: false , filterable: true},
    { title: 'Sistema', field: 'sistema', editable: 'never', filtering: false, filterable: true },
    {
      title: 'CND Municipal',
      field: 'cnd_municipal',
      editable: 'never',
      filtering: false,
      filterable: true
    },
    {
      title: 'Método de Acesso',
      field: 'metodo_acesso',
      editable: 'never',
      filtering: false,
      ilterable: true
    },
  ]);

  useEffect(() => {
    async function getStates() {
      const response = await instanceAxios(
        localStorage.getItem('toobiauth')
      ).get('/caracteristicasprefeitura');

      setStates(response.data);
      setOriginalStates(response.data);
    }

    getStates();
  }, []);

  function handleModal() {
    return setModal(!modal);
  }

  const clickAlert = () => {
    setAlert(0);
  };

  async function handleSubmit(event) {
    event.preventDefault();

    const data = {
      estado: state.toUpperCase(),
      cidade: city.toUpperCase(),
      sistema: system,
      cnd_municipal: cnd,
      metodo_acesso: accessMethod,
    };

    if (id) {
      return await instanceAxios(localStorage.getItem('toobiauth'))
        .put('/caracteristicasprefeitura', { ...data, id })
        .then((res) => {
          if (res) {
            setAlert(2);
            handleModal();
            setTimeout(() => {
              window.location.reload();
            }, [1500]);
          }
        })
        .catch((error) => {
          setAlert(3);
          handleModal();
        });
    }

    return await instanceAxios(localStorage.getItem('toobiauth'))
      .post('/caracteristicasprefeitura', data)
      .then((res) => {
        if (res) {
          setAlert(2);
          handleModal();
          setTimeout(() => {
            window.location.reload();
          }, [1500]);
        }
      })
      .catch((error) => {
        setAlert(3);
        handleModal();
      });
  }

  const openModalFilter = (event, columnid) => {
    setFilterText('')
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top , left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);

    const filteredDas = originalStates.filter(item => {
      const value = getValueColumnId(columnId,item);
      return value && value.toString().toLowerCase().includes(filterText.toLowerCase());
    });
    // Update the table data with filtered data
    setStates(filteredDas);
  };

  const getValueColumnId = (columnIdAux,rowData) => {
    columnIdAux = columnIdAux.replace(/"/g, '');

    const parts = columnIdAux.split('.');

    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  }

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setStates(originalStates);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;


    if (idOrder === property && order === 'desc') {
      setOrder('asc')
    }else{
      setOrder('desc')
    }


    setIdOrder(orderBy);

  };

  const sortTable = (property) => {


    const isAsc = order === 'asc';
    states.sort((a, b) => {
      let aValue = getValueColumnId(property,a);
      let bValue = getValueColumnId(property,b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setStates(states);
  };

  return (
    <>
      <MaterialTable
        title="Características Prefeitura"
        columns={tableColumns}
        data={states}
        style={{ width: '100%' }}
        components={{
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <div style={{ padding: '0 10px', marginLeft: '13px' }}>
                <Button
                  variant="contained"
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={() => {
                    handleModal();
                    setId('');
                    setState('');
                    setCity('');
                    setSystem('');
                    setCnd('');
                    setAccessMethod('');
                  }}
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                  }}
                >
                  Novo
                </Button>
              </div>
              <div
                style={{
                  padding: '0 10px',
                  marginLeft: '13px',
                  marginTop: '10px',
                }}
              >
                <Collapse in={alert === 3}>
                  <Alert severity="error" onClick={clickAlert}>
                    Erro criar/editar características!
                  </Alert>
                </Collapse>
                <Collapse in={alert === 2}>
                  <Alert severity="success" onClick={clickAlert}>
                    Cidade criada/editada com sucesso!
                  </Alert>
                </Collapse>
              </div>
            </div>
          ),
        }}
        localization={{
          header: {
            actions: 'Ações',
          },
          toolbar: {
            searchTooltip: 'Pesquisar',
            searchPlaceholder: 'Pesquisar',
          },
          pagination: {
            labelRowsSelect: 'linhas',
            labelDisplayedRows: '{count} de {from}-{to}',
            firstTooltip: 'Primeira página',
            previousTooltip: 'Página anterior',
            nextTooltip: 'Próxima página',
            lastTooltip: 'Última página',
          },
        }}
        options={{
          actionsColumnIndex: -1,
          filtering: true,
        }}
        actions={[
          {
            icon: EditIcon,
            tooltip: 'Editar',
            onClick: (event, rowData) => {
              handleModal();
              setId(rowData.id);
              setState(rowData.estado);
              setCity(rowData.cidade);
              setSystem(rowData.sistema);
              setCnd(rowData.cnd_municipal);
              setAccessMethod(
                rowData.metodo_acesso !== null
                  ? rowData.metodo_acesso
                  : accessMethod
              );
            },
          },
        ]}
      />

      <Modal
        open={modal}
        onClose={handleModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Grid
          container
          spacing={3}
          className={classes.paper}
          style={{
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
            width: 'auto',
            height: '50%',
            overflow: 'auto',
          }}
        >
          <form onSubmit={handleSubmit}>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={2}>
                  <TextField
                    name="estado"
                    label="Estado"
                    variant="outlined"
                    inputProps={{
                      maxLength: 2,
                    }}
                    required
                    autoFocus
                    value={state}
                    onChange={({ target }) => setState(target.value)}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Cidade"
                    variant="outlined"
                    required
                    value={city}
                    onChange={({ target }) => setCity(target.value)}
                  />
                </Grid>

                <Grid item xs={2}>
                  <TextField
                    label="Sistema"
                    variant="outlined"
                    required
                    value={system}
                    onChange={({ target }) => setSystem(target.value)}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="CND Municipal"
                    variant="outlined"
                    required
                    value={cnd}
                    onChange={({ target }) => setCnd(target.value)}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    select
                    label="Método de acesso"
                    variant="outlined"
                    required
                    value={accessMethod}
                    onChange={({ target }) => setAccessMethod(target.value)}
                  >
                    {accessMethodOptions.map((access) => (
                      <MenuItem key={access.value} value={access.value}>
                        {access.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<SaveIcon />}
                  style={{
                    backgroundColor: XMEI_PRIMARY_COLOR,
                    color: '#FFF',
                    position: 'absolute',
                    bottom: '20px',
                  }}
                >
                  Salvar
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  type="button"
                  variant="contained"
                  startIcon={<CloseIcon />}
                  onClick={() => setModal(!modal)}
                  style={{
                    backgroundColor: XMEI_SECONDARY_COLOR,
                    color: '#FFF',
                    position: 'absolute',
                    bottom: '20px',
                    right: '30px',
                  }}
                >
                  Fechar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Modal>
    </>
  );
}

export default CaracteristicasPrefeitura;
